export const getAssetsURL = (path: string) =>
  `${import.meta.env.VITE_IMAGE_BASE_URL}${path}`;
